import { ReactNode, useCallback, useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

export type PortalContainer = () => HTMLElement | null

interface PortalProps {
  children: ReactNode
}

export const usePortal = (container?: PortalContainer) => {
  const rootElementRef = useRef<HTMLElement>(document.body)

  useEffect(() => {
    rootElementRef.current = container?.() || document.body
  }, [container])

  return useCallback(
    ({ children }: PortalProps) => createPortal(children, rootElementRef.current),
    [],
  )
}
